import ConfirmModal from '@/components/ConfirmModal';
import { TransText } from '@/i18n/trans/text';
import { Typography } from '@fleet/webshop-ui';
import { type FC } from 'react';

interface BookingAboutToExpireDialogProps {
  open: boolean;
  timeTillExpiry: string;
  setOpen: (value: boolean) => void;
  onCancel: () => void;
}

const BookingAboutToExpireDialog: FC<BookingAboutToExpireDialogProps> = ({
  open,
  timeTillExpiry,
  setOpen,
  onCancel,
}) => {
  const [minutes, seconds] = timeTillExpiry.split(':');

  const parsedMinutes = parseInt(minutes);
  const parsedSeconds = parseInt(seconds);

  return (
    <ConfirmModal
      open={open}
      setOpen={setOpen}
      onCancel={onCancel}
      title={<TransText i18nKey="sessionAboutToExpire" />}
      description={
        <div className="flex flex-wrap gap-1">
          <Typography variant="paragraph">
            <TransText i18nKey="bookingSessionExpiresIn" />:
          </Typography>
          <span className="flex items-center gap-1">
            <Typography variant="paragraph">
              <TransText
                i18nKey="minutesCount"
                values={{ count: parsedMinutes }}
              />
            </Typography>
            <Typography variant="paragraph">
              <TransText
                i18nKey="secondsCount"
                values={{ count: parsedSeconds }}
              />
            </Typography>
          </span>
        </div>
      }
      cancelLabel="dismissWarning"
      showClose={false}
    />
  );
};

export default BookingAboutToExpireDialog;
